export default {"src":"/_next/static/media/seasonsGif.deb2f3c6.gif","height":750,"width":750};